export enum GarageTypeEnum {
  EXTERNAL_GARAGE = 'EXTERNAL_GARAGE',
  OFFICE_GARAGE = 'OFFICE_GARAGE',
}
